import React from 'react';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../services/ApiService';

export const NewPasswordPage: React.FC = () => {
  const [password, setPassword] = React.useState('');
  const [confirm, setConfirm] = React.useState('');
  const [error, setError] = React.useState<string | null>(null);
  const [success, setSuccess] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();

  React.useEffect(() => {
    // Supabase will automatically update the session if the hash is present
    // No need to parse token manually
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!password || password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await apiService.updateUserPassword(password);
      setSuccess(true);
    } catch (err: any) {
      setError(err.message || 'Failed to update password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md bg-white border border-gray-200 rounded-xl shadow-sm p-6">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-normal text-gray-900 mb-2">Set a new password</h1>
          <p className="text-gray-600 text-sm">Enter your new password below.</p>
        </div>
        {success ? (
          <div className="text-center text-green-600 mb-4">Password updated! <button className="underline text-blue-600" onClick={() => navigate('/login')}>Go to login</button></div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <label htmlFor="password" className="text-sm font-normal text-gray-700">New Password</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={8}
                disabled={loading}
                className="w-full h-11 border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-gray-900"
                placeholder="Enter new password"
              />
            </div>
            <div className="space-y-2">
              <label htmlFor="confirm" className="text-sm font-normal text-gray-700">Confirm Password</label>
              <input
                id="confirm"
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
                minLength={8}
                disabled={loading}
                className="w-full h-11 border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-gray-900"
                placeholder="Confirm new password"
              />
            </div>
            {error && <div className="text-red-600 text-sm">{error}</div>}
            <button
              type="submit"
              disabled={loading || !password || !confirm}
              className="w-full h-11 bg-gray-900 hover:bg-gray-800 text-white rounded-md text-sm font-normal disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {loading ? 'Updating...' : 'Set new password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};
